// removed by extract-text-webpack-plugin
module.exports = {"Bar":"purify_ProgressBarIcon__Bar___85vb0","BarContainer":"purify_ProgressBarIcon__BarContainer___2jjpJ","fill-bar":"purify_ProgressBarIcon__fill-bar___3i1Dj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProgressBarIcon/ProgressBarIcon.scss
// module id = 256
// module chunks = 0